import { render } from "./RequestNewFund.vue?vue&type=template&id=aa316612"
import script from "./RequestNewFund.vue?vue&type=script&lang=js"
export * from "./RequestNewFund.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__